import * as o from "react";
import { j as p } from "./useTheme-efe1290c.js";
import * as x from "react-dom";
import { _ as P, p as u } from "./createTheme-02ce03eb.js";
import { a as N, s as c } from "./useThemeProps-ee4acb93.js";
import { a as f } from "./useEventCallback-fe4fd69c.js";
const h = "exact-prop: ​";
function y(e) {
  return process.env.NODE_ENV === "production" ? e : P({}, e, {
    [h]: (s) => {
      const n = Object.keys(s).filter((t) => !e.hasOwnProperty(t));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((t) => `\`${t}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function C(e, s, n, t, l) {
  if (process.env.NODE_ENV === "production")
    return null;
  const r = e[s], a = l || s;
  return r == null ? null : r && r.nodeType !== 1 ? new Error(`Invalid ${t} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const O = {
  disableDefaultClasses: !1
}, b = /* @__PURE__ */ o.createContext(O);
function g(e) {
  const {
    disableDefaultClasses: s
  } = o.useContext(b);
  return (n) => s ? "" : e(n);
}
function v(e) {
  return typeof e == "function" ? e() : e;
}
const i = /* @__PURE__ */ o.forwardRef(function(s, n) {
  const {
    children: t,
    container: l,
    disablePortal: r = !1
  } = s, [a, d] = o.useState(null), m = N(/* @__PURE__ */ o.isValidElement(t) ? t.ref : null, n);
  if (f(() => {
    r || d(v(l) || document.body);
  }, [l, r]), f(() => {
    if (a && !r)
      return c(n, a), () => {
        c(n, null);
      };
  }, [n, a, r]), r) {
    if (/* @__PURE__ */ o.isValidElement(t)) {
      const E = {
        ref: m
      };
      return /* @__PURE__ */ o.cloneElement(t, E);
    }
    return /* @__PURE__ */ p.jsx(o.Fragment, {
      children: t
    });
  }
  return /* @__PURE__ */ p.jsx(o.Fragment, {
    children: a && /* @__PURE__ */ x.createPortal(t, a)
  });
});
process.env.NODE_ENV !== "production" && (i.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: u.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: u.oneOfType([C, u.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: u.bool
});
process.env.NODE_ENV !== "production" && (i["propTypes"] = y(i.propTypes));
const j = i;
export {
  C as H,
  j as P,
  y as e,
  g as u
};
